<template>
  <general-layout class="kp-modal-small" v-show="'delete-account' === visibleModal" @close="modalClose()">
    <h4 class="modal-title" slot="header">
      {{ $t('modal.delete.title') }}
    </h4>

    <div class="help-block" slot="body">
      <i class="fa fa-exclamation-triangle"></i>
      {{ $t('modal.delete.message') }}
    </div>

    <div slot="footer">
        <button type="button" class="btn btn-danger pull-right" @click="deleteAccount();">
          {{ $t('modal.delete.confirm') }}
        </button>
        <button type="button" class="btn pull-right" @click="modalClose()">
          {{ $t('modal.delete.cancel') }}
        </button>
    </div>
  </general-layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import generalLayout from '../../../shared/components/modal/GeneralLayout';

export default {
  components: {
    generalLayout,
  },
  methods: {
    deleteAccount() {
      this.delete(this.active.id);
    },
    ...mapActions({
      modalClose: 'modal/close',
      delete: 'account/delete',
    }),
  },
  computed: {
    ...mapGetters({
      visibleModal: 'modal/default',
      active: 'account/active',
    }),
  },
};
</script>



// WEBPACK FOOTER //
// DeleteAccount.vue?ecbb9d10